import type { ProductionLineModel } from '@/types/models/ProductionLineModel'

export type ProductionLineState = {
    productionLines: ProductionLineModel[]
    productionLine?: ProductionLineModel
}

export enum EProductionLineActions {
    FETCH_PRODUCTION_LINE = 'fetchProductionLines',
    FETCH_PRODUCTION_LINES = 'fetchProductionLine',
    CREATE_PRODUCTION_LINE = 'createProductionLine',
    UPDATE_PRODUCTION_LINE = 'updateProductionLine',
    DELETE_PRODUCTION_LINE = 'deleteProductionLine',
    RESET_PRODUCTION_LINE = 'resetProductionLine'
}

export enum EProductionLineMutations {
    SET_PRODUCTION_LINE = 'setProductionLines',
    SET_PRODUCTION_LINES = 'setProductionLine',
    SET_LOADING = 'setLoading',
    SET_PAGINATION = 'setPagination',
    REMOVE_PRODUCTION_LINE = 'removeProductionLine',
    RESET_PRODUCTION_LINE = 'resetProductionLine'
}
